import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { confirmable, createConfirmation } from 'react-confirm';
import './style.css';

const Confirmation = ({
    okLabel = 'OK',
    cancelLabel = 'Cancel',
    title = 'Confirmation',
    confirmation,
    show,
    proceed,
    enableEscape = true,
}) => {
    return (
        <div className="static-modal">
            <Modal
                animation={false}
                className='confirmContainer'
                show={show}
                onHide={() => proceed(false)}
                backdrop={enableEscape ? true : 'static'}
                keyboard={enableEscape}
            >
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {confirmation}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='jamlyfOutlineBtn' onClick={() => proceed(true)}>{okLabel}</Button>
                    <Button variant='danger' onClick={() => proceed(false)}>{cancelLabel}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
};

const confirm = (confirmation, proceedLabel = "OK", cancelLabel = "cancel", options = {}) => {
    return createConfirmation(confirmable(Confirmation))({
        confirmation,
        proceedLabel,
        cancelLabel,
        ...options
    });
};
export default confirm;
